<template>
  <div class="salesman-withdrawal">
    <!-- 未认证、未通过 -->
    <div class="incomerule">
      <div class="income clearfix">
        <div class="pic">
          <img src="@static/images/money_1.png" alt="" />
        </div>
        <div class="sr pointer" @click="goWaitList">
          <div class="xl">
            <span class="el-dropdown-link"> 待结算金额 <i class="icon-youjiantou"></i></span>
          </div>
          <div class="num">{{ meansData.waitSettlement | fixedNum1 }}元</div>
        </div>
        <div class="sr">
          <div class="xl">
            <span class="el-dropdown-link"> 已结算金额 </span>
          </div>
          <div class="num">{{ meansData.settlement | fixedNum1 }}元</div>
        </div>
      </div>
      <el-tabs value="1">
        <el-tab-pane label="已结算账单" name="1"> </el-tab-pane>
      </el-tabs>
      <div class="tabtal">
        <div class="block">
          <span class="label">日期</span>
          <el-select v-model="dateType" placeholder="请选择" style="width: 100px">
            <el-option label="按月" value="1"></el-option>
            <el-option label="按年" value="2"></el-option>
          </el-select>
          <el-date-picker type="month" v-model="monthDate" placeholder="选择日期" v-if="dateType == '1'" value-format="yyyy-MM"></el-date-picker>
          <el-date-picker type="year" v-model="yearDate" placeholder="选择日期" v-if="dateType == '2'" value-format="yyyy"></el-date-picker>
          <span class="label">结算类型</span>
          <el-select v-model="type" placeholder="请选择" style="width: 110px" clearable>
            <el-option :label="text" :value="value" v-for="(text, value) in typeMap" :key="value"></el-option>
          </el-select>
          <el-button type="warning" @click="changeDate()">查询</el-button>
        </div>

        <el-table tooltip-effect="dark" :data="readListData" border stripe class="omtable" style="width: 100%">
          <el-table-column prop="balanceDate" label="结算日期" width="140" min-width="160px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type" label="结算类型" :show-overflow-tooltip="true" min-width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 3"
                >活动<span v-if="scope.row.activityName">-{{ scope.row.activityName }}</span></span
              >
              <span v-else>{{ all.BALANCE_TYPE[scope.row.type] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payNum" label="期数" v-if="curType == 2 || !curType" :show-overflow-tooltip="true" min-width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.payNum || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="policyFeeSum" label="总保费（元）" :show-overflow-tooltip="true" min-width="120px"></el-table-column>
          <el-table-column prop="policyNum" label="保单数" :show-overflow-tooltip="true" min-width="100px"></el-table-column>
          <el-table-column prop="policyIncomes" label="应结费用（元）" :show-overflow-tooltip="true" min-width="140px">
            <template slot-scope="scope">
              <span>{{ scope.row.policyIncomes }}</span>
              <activityTip v-if="scope.row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="scope.row.activityIncomes"></activityTip>
            </template>
          </el-table-column>
          <el-table-column prop="incomeTax" label="实际收入（元）" :show-overflow-tooltip="true" min-width="140px"></el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="danger" @click="readDetail(scope.row)">结算明细</el-button>
                <!-- <el-button type="warning" @click="download(scope.row)" :disabled="scope.row.balanceStatus == 1" v-if="mechanUserType == 1"
                  >结算函下载</el-button
                > -->
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="bls">
          <el-pagination
            :current-page.sync="readCurrent"
            @current-change="readListFun"
            :page-size="10"
            background
            layout="total,prev, pager, next, jumper"
            :total="readtotalPage"
          ></el-pagination>
        </div>


      </div>
    </div>
    <!-- 结算规则历史 -->
    <settlement-explain-history-modal ref="settlementExplainHistoryModal" />
    <!-- 提现期数弹窗 -->
    <withdrawal-number-modal ref="withdrawalNumberModal" @submit="$refs.withdrawalDetailModal.open('add', $event)" />
    <!-- 提现详情 -->
    <withdrawal-detail-modal ref="withdrawalDetailModal" @reload="reload(false)" @jumpWithdraw="jumpWithdraw" @submit="$refs.withdrawalForm.open($event)" />
    <!-- 企业提现表单 -->
    <withdrawal-form-by-mechan ref="withdrawalFormByMechan" @reload="reload(true)" @openInvoiceDetail="$refs.invoiceDetailModal.open()" />
    <!-- 个人机构提现表单 -->
    <withdrawal-form ref="withdrawalForm" @reload="reload(true)" />
    <!-- 提现期数弹窗 -->
    <invoiceDetailModal ref="invoiceDetailModal" :subCompanysList="subCompanysList" />
  </div>
</template>
<script>
//当前实例组件
import activityTip from '@/components/activityTip';
import withdrawalNumberModal from './component/withdrawalNumberModal';
import withdrawalFormByMechan from './component/withdrawalFormByMechan';
import withdrawalForm from './component/withdrawalForm';
import withdrawalDetailModal from './component/withdrawalDetailModal';
import invoiceDetailModal from './component/invoiceDetailModal';
import settlementExplainHistoryModal from './component/settlementExplainHistoryModal';
export default {
  data: () => {
    return {
      typeMap: {},
      subCompanyId: '',
      sealImgList: [], //提现盖章图片
      subCompanysList: [], //分公司列表
      level: 1,
      isXbbSecondMechan: 0,
      readtotalPage: 0,
      readCurrent: 1,
      tabsCurrent: 1,
      dialogVisible: false,
      close: false,
      meansData: {}, //财产数据
      activeName2: 'first',
      activeName3: '1',
      dateType: '1', //1按月 2 按年
      policyType: '1', //保单类型
      monthDate: '', //日期
      yearDate: '', //日期
      dateType2: '1', //提现日期类型 1申请日期 2 转账日期
      date: '', //提现查询日期
      type: '', //结算类型
      curType: '', //当前查询的结算类型
      type2: '', //提现类型
      all: { BANK_TYPE: [] },
      pageLoading: false,
      bankLoading: false,
      getcodeflage: true, //获取验证码标记
      getcodetext: '验证码',
      timer: {}, //验证码计时器
      isflageNum: 0, //上传发票的状态
      policy_Status: {},
      cashStatus: '',
      totalPage: 0, //提现记录总分页数
      readListData: [],
      tableData: [],
      detailData: '',
      balanceId: '',
      mechanUserType: 1, //客户类型
      isOpenSecond: 0, //是否有二开权限
      radio: true,
      status: '-1'
    };
  },
  components: {
    activityTip,
    withdrawalNumberModal,
    withdrawalDetailModal,
    withdrawalForm,
    withdrawalFormByMechan,
    invoiceDetailModal,
    settlementExplainHistoryModal
  },
  created() {
    this.readCurrent = 1;
    const user = this.$tools.getLocal('userinfo');
    this.level = user.level;
    this.isXbbSecondMechan = user.isXbbSecondMechan;
    this.queryMechanInfo();
    this.checkMeans();
    this.readListFun(1);
    this.getCashPostal();
    this.getUserInfo();
    this.getSubCompanys();
    this.$tools.getall(data => {
      this.all = data;
      this.getTypeMap();
    });
  },
  methods: {
    // 结算函下载
    download(item) {
      location.href = '/master/means/balanceConfirmDownload?balanceId=' + item.id;
    },
    // 获取结算类型字典
    getTypeMap() {
      const map = this.all.BALANCE_TYPE;
      if (this.level != 1 && this.isXbbSecondMechan != 1) {
        // 不是1级且不是新保保 删除活动选项
        delete map['3'];
      }
      delete map['5'];
      this.typeMap = map;
    },
    // 分公司列表
    getSubCompanys() {
      this.$http({
        url: '/master/content/querySubCompanys',
        type: 'put',
        params: {}
      }).then(res => {
        this.subCompanysList = res.data;
      });
    },
    // 跳转待生效列表
    goWaitList() {
      this.$router.push('/salesmanWaitSettlement');
    },
    getUserInfo() {
      let url;
      if (this.accpimtType == 1) {
        //企业
        url = '/master/mechan/read/enterprise/detail';
      } else {
        //个人
        url = '/master/mechan/read/individual/detail';
      }
      this.$http({
        url: url,
        type: 'get'
      }).then(res => {
        this.status = res.data.auditStatus;
      });
    },
    xyflage: function() {
      this.$router.push('/costAgreement');
    },
    queryMechanInfo: function() {
      this.$http({
        url: '/master/mechan/queryMechanInfo',
        type: 'put',
        params: {}
      }).then(data => {
        this.mechanUserType = data.data.mechanUserType; //1机构2个人
        this.isOpenSecond = data.data.isOpenSecond;
      });
    },
    changeradio: function() {
      this.radio = !this.radio;
    },
    getCashPostal() {
      //提现状态
      var that = this;
      this.$http({
        url: '/master/means/getCashPostal',
        type: 'put',
        params: {}
      }).then(function(data) {
        that.cashStatus = data.data.cashStatus;
      });
    },
    changeDate() {
      //时间选择事件
      if (this.activeName2 == 'first') {
        this.readListFun(1); //查询业绩
        this.readCurrent = 1;
      } else {
        this.tabsFun(1); //提现记录
        this.tabsCurrent = 1;
      }
    },
    readDetail(row) {
      sessionStorage.setItem('salesmanSettlementDetail' + row.id, JSON.stringify(row));
      //收益明细查看详情
      this.$router.push({
        path: '/finance/salesmanSettlementDetail',
        query: {
          fromPage: 'withdraw',
          detailId: row.id,
          text: row.balanceDate,
          policyType: row.policyType,
          activityType: row.activityType,
          type: row.type
        }
      });
    },
    checkMeans() {
      //业绩核对
      var that = this;
      this.$http({
        url: '/master/means/userInfo',
        type: 'put',
        params: {}
      }).then(function(data) {
        that.meansData = data.data;
      });
    },
    tabsFun(num) {
      //结算记录
      const params = {
        pageNum: num,
        pageSize: 10,
        cashStatus: this.type2
      };
      // 申请日期
      if (this.dateType2 == '1' && this.date && this.date.length == 2) {
        params.createTimeStart = this.date[0];
        params.createTimeEnd = this.date[1];
      }
      // 发放日期
      if (this.dateType2 == '2' && this.date && this.date.length == 2) {
        params.checkTimeStart = this.date[0];
        params.checkTimeEnd = this.date[1];
      }
      if (this.dateType2 == '2') {
        delete params.cashStatus;
      }
      if (this.activeName2 == 'second') {
        if (this.activeName3 == '1') {
          params.cashStatusIn = [5];
        } else if (this.activeName3 == '2') {
          params.cashStatusIn = [1, 2, 3, 4, 6];
        }
      }
      this.pageLoading = true;
      this.$http({
        url: '/master/means/list/cashPostal',
        type: 'put',
        params: params
      })
        .then(data => {
          this.tableData = data.data;
          this.totalPage = data.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    updateMeans() {
      //结算
      if (this.meansData.validCashPostal < 100) {
        return this.$message.error('提现金额需大于或等于100元！');
      }
      if (this.mechanUserType == 2) {
        //个人
        if (this.radio) {
          this.$refs.withdrawalNumberModal.open();
        } else {
          return this.$message.error('请勾选服务协议');
        }
      } else if (this.level == 2 || this.level == 1) {
        //1级、2级企业
        this.$refs.withdrawalNumberModal.open();
      }
    },
    // 撤销提现
    delWithdraw(row) {
      this.$confirm('确定撤销提现？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/master/means/delWaitUploadWithdraw?cashPostalId=' + row.id,
          type: 'delete',
          params: {}
        }).then(res => {
          this.reload();
          this.$message.success('操作成功');
        });
      });
    },
    // 刷新页面数据
    reload() {
      this.tabsCurrent = 1;
      this.cashStatus = 2; //更新
      this.checkMeans(); //余额数据更新
      this.tabsFun(1); //提现记录更新
    },
    readListFun(num) {
      //业绩查询
      var params = {
        pageNum: num,
        pageSize: 10,
        asc: false,
        type: this.type,
        policyType: this.policyType,
        balanceStatus: '5',
        subCompanyId: this.subCompanyId,
        orderBy: 'id'
      };
      // 按月
      if (this.dateType == '1' && this.monthDate) {
        params.balanceDate = this.monthDate;
      }
      // 按年
      if (this.dateType == '2' && this.yearDate) {
        params.balanceYear = this.yearDate;
      }
      this.pageLoading = true;
      this.$http({
        url: '/master/content/UserBalances/list',
        type: 'put',
        params: params
      })
        .then(data => {
          this.curType = this.type;
          this.readListData = data.data;
          this.readtotalPage = data.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleClick(tabLevel) {
      this.$tools.cancelhttpRequest();
      this.tableData = [];
      if (tabLevel == 1) {
        if (this.mechanUserType == 1 && this.level == 1) {
          this.activeName3 = '1';
        } else {
          this.activeName3 = '2';
        }
      }
      if (this.activeName2 == 'first') {
        this.readListFun(1);
        this.readCurrent = 1;
      } else {
        this.tabsFun(1);
        this.tabsCurrent = 1;
      }
    },
    // 跳转提现记录
    jumpWithdraw() {
      this.activeName2 = 'second';
      this.activeName3 = '1';
      this.tabsCurrent = 1;
      this.tabsFun(1);
    },

    // 批量下载结算函
    downloadFile(item) {
      this.$tools.daochu('/master/means/balanceConfirmDownload', {
        cashPostalId: item.id
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './salesmanWithdrawal.scss';
</style>
